var _path, _path2, _path3, _defs;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHome = function SvgHome(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4008 3.81692C11.995 3.18355 12.2921 2.86687 12.6413 2.7548C12.9228 2.66446 13.2255 2.66446 13.507 2.7548C13.8562 2.86687 14.1533 3.18355 14.7475 3.81692L21.2157 10.7112C22.3841 11.9566 22.9683 12.5793 22.9859 13.1126C22.9999 13.5362 22.8233 13.9439 22.5048 14.2236C22.1039 14.5756 21.25 14.5756 19.5423 14.5756H6.60598C4.89828 14.5756 4.04443 14.5756 3.64348 14.2236C3.32494 13.9439 3.14841 13.5362 3.16239 13.1126C3.17999 12.5793 3.7642 11.9566 4.93263 10.7112L11.4008 3.81692Z",
    fill: "#2595FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.583 10.8137H8.37667H8.36874C7.70777 10.8136 7.20155 10.8136 6.80921 10.8664C6.41243 10.9197 6.11718 11.0287 5.88808 11.2578C5.65898 11.4869 5.55004 11.7821 5.49669 12.1789C5.44394 12.5713 5.44394 13.0775 5.44395 13.7384V13.7464V19.5889V19.5968C5.44394 20.2578 5.44394 20.764 5.49669 21.1563C5.55004 21.5531 5.65898 21.8484 5.88808 22.0775C6.11718 22.3066 6.41243 22.4155 6.80921 22.4689C7.20156 22.5216 7.70778 22.5216 8.36876 22.5216H8.37667H9H9.0078C9.47259 22.5216 9.83163 22.5216 10.1106 22.4841C10.394 22.446 10.6097 22.3675 10.7778 22.1994C10.9459 22.0313 11.0244 21.8156 11.0625 21.5322C11.1 21.2532 11.1 20.8942 11.1 20.4294V20.4216V19C11.1 18.8957 11.1435 18.7234 11.2351 18.5172C11.3255 18.3138 11.4586 18.0868 11.6281 17.875C11.9692 17.4486 12.4435 17.1 13 17.1C13.711 17.1 14.1831 17.4534 14.4811 17.8706C14.7825 18.2925 14.9 18.7724 14.9 19V20.4216V20.4294C14.9 20.8942 14.9 21.2532 14.9375 21.5322C14.9756 21.8156 15.0541 22.0313 15.2222 22.1994C15.3903 22.3675 15.606 22.446 15.8894 22.4841C16.1684 22.5216 16.5274 22.5216 16.9922 22.5216H17H17.583H17.5909C18.2519 22.5216 18.7582 22.5216 19.1505 22.4689C19.5473 22.4155 19.8425 22.3066 20.0716 22.0775C20.3007 21.8484 20.4097 21.5531 20.463 21.1563C20.5158 20.764 20.5158 20.2578 20.5158 19.5968V19.5889V13.7464V13.7385C20.5158 13.0775 20.5158 12.5713 20.463 12.1789C20.4097 11.7821 20.3007 11.4869 20.0716 11.2578C19.8425 11.0287 19.5473 10.9197 19.1505 10.8664C18.7582 10.8136 18.2519 10.8136 17.591 10.8137H17.583Z",
    stroke: "url(#paint0_linear_51_809)",
    strokeOpacity: 0.6,
    strokeWidth: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.54395 13.7464C5.54395 12.411 5.54395 11.7433 5.95879 11.3285C6.37363 10.9137 7.04131 10.9137 8.37667 10.9137H17.583C18.9184 10.9137 19.5861 10.9137 20.0009 11.3285C20.4158 11.7433 20.4158 12.411 20.4158 13.7464V19.5889C20.4158 20.9242 20.4158 21.5919 20.0009 22.0068C19.5861 22.4216 18.9184 22.4216 17.583 22.4216H17C16.0572 22.4216 15.5858 22.4216 15.2929 22.1287C15 21.8358 15 21.3644 15 20.4216V19C15 18.5 14.5 17 13 17C11.8 17 11 18.5 11 19V20.4216C11 21.3644 11 21.8358 10.7071 22.1287C10.4142 22.4216 9.94281 22.4216 9 22.4216H8.37667C7.04131 22.4216 6.37363 22.4216 5.95879 22.0068C5.54395 21.5919 5.54395 20.9242 5.54395 19.5889V13.7464Z",
    fill: "#67B6FE",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_51_809",
    x: -2.65601,
    y: 2.71365,
    width: 31.2717,
    height: 27.908,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_51_809"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_51_809",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_51_809",
    x: 1.54395,
    y: 6.91365,
    width: 22.8718,
    height: 19.508,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_51_809"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_51_809",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_51_809",
    x1: 4.48167,
    y1: 11.9598,
    x2: 22.8992,
    y2: 24.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHome, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Home.cf17c5cf.svg";
export { ForwardRef as ReactComponent };